import { render, staticRenderFns } from "./OldPostComments.vue?vue&type=template&id=3d9772b7&scoped=true&"
import script from "./OldPostComments.vue?vue&type=script&lang=js&"
export * from "./OldPostComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9772b7",
  null
  
)

export default component.exports